/* eslint-disable nordic/no-img-tags */
const React = require('react');
const Card = require('@andes/card');
const Button = require('@andes/button');
const Image = require('nordic/image');
const { getEventTracker } = require('../../../../../../utils/event-tracker');

const { CardContent } = Card;

const DevProgramBanner = ({ i18n, assetsPath = '', lang }) => {
  const Tracker = getEventTracker();

  const clickEvent = () => {
    Tracker.send('mpdevelopers/click_online_payments_dev_program_banner');
  };

  return (
    <Card className="online-payments-main-banner--card" paddingSize={0}>
      <CardContent>
        <div className="online-payments-main-banner">
          <div className="online-payments-main-banner--content">
            <span className="online-payments-main-banner--title">{i18n.gettext('Únete al <dev>program')}</span>
            <span className="online-payments-main-banner--text">{i18n.gettext('Certifícate en Checkout Pro para formar parte del programa')}.</span>
            <Button
              className="online-payments-main-banner--button"
              href={`/developers/${lang}/developer-program`}
              target="_blank"
              onClick={clickEvent}
            >
              {i18n.gettext('Conocer más')}
            </Button>
          </div>
          <Image
            className="online-payments-main-banner--image"
            src={`${assetsPath}images/dev_program_guides_landing.png`}
            alt=""
          />
        </div>
      </CardContent>
    </Card>
  );
};

module.exports = DevProgramBanner;
